'use client'

import React from 'react'
import s from './WithColorInBackgroundWrapper.module.scss'
import { classnames } from '@/utils/classnames'

//musi być aktualne z kolorami w s/_colors.scss
type BackgroundColor =
  | 'transparent'
  | 'white'
  | 'black'
  | 'gray-dark'
  | 'gray'
  | 'gray-light'
  | 'gray-light2'
  | 'bright'
  | 'main-light'
  | 'main'
  | 'main-dark'
  | 'accent-bright'
  | 'accent-light'
  | 'accent'
  | 'accent-dark'
  | 'gradient-accent'

type WithColorInBackgroundWrapperStyle = {
  root?: React.CSSProperties
  container?: React.CSSProperties
}

export function WithColorInBackgroundWrapper({
  children,
  backgroundColor = 'gray-dark',
  style = {},
  className,
}: {
  children: React.ReactNode
  backgroundColor?: BackgroundColor
  style?: WithColorInBackgroundWrapperStyle
  className?: string
}) {
  return (
    <div
      className={classnames(s.root, s[backgroundColor], className ?? '')}
      style={style.root}
    >
      <div className={classnames(s.container)} style={style.container}>
        {children}
      </div>
    </div>
  )
}
